import type { GetAppRolesQuery } from '@user-management/graphql';

import type { AppRole } from './type';

export function mapAppRoleListData(data: GetAppRolesQuery['getAppRoles']['roles']): AppRole[] {
  return data.map((role) => ({
    id: role.id,
    name: role.name,
    description: role.description ?? '',
  }));
}
